<template>
  <div>
    <template v-for="field in fields">
      <ValueHelpWrapper
        v-if="field.type == 'report-filter-value-help'"
        :key="field.name"
        :field="field"
        :value="formValues[field.name]"
        :fullObject="fullObjects[field.name] || []"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
        @update:fullObject="$emit('update:fullObjects', { key: field.name, value: $event })"
      />
      <CustomInput
        v-else-if="field.type == 'custom-input'"
        :key="'custom-' + field.name"
        :field="field"
        :value="formValues[field.name]"
        @input="$emit('update:formValues', { key: field.name, value: $event })"
      />
      <FormulateInput v-else v-bind="field" :key="'input-' + field.name" />
      <div v-if="field.isRequired" :key="`required-${field.name}`" class="ms-1 mt-1 fst-italic">
        <span class="text-danger">*</span> {{ $t('report.filters.required') }}
      </div>
    </template>
  </div>
</template>

<script>
import { GET_DRIVER_FILTER } from '@/services/api/master/employees'
import { GET_VEHICLE_FILTER } from '@/services/api/master/fleet'
import { GET_GEOFENCES_FILTER } from '@/services/api/master/geofence'
import { mapGetters } from 'vuex'
import CustomInput from './wrapper/CustomInput'
import ValueHelpWrapper from './wrapper/ValueHelpWrapper'

import { GET_RITAGE_GEOFENCES } from '@/services/api/master/ritage'
import reportFilterFields from './lib/reportFilterFields'

export default {
  components: {
    ValueHelpWrapper,
    CustomInput,
  },
  mixins: [reportFilterFields],
  props: {
    formValues: {
      type: Object,
      default: () => ({}),
    },
    fullObjects: {
      type: Object,
      default: () => ({}),
    },
    report: {
      type: Object,
      required: true,
    },
    parameter: {
      type: String,
      default: 'filter',
    },
  },
  emits: ['update:formValues', 'update:fullObjects'],
  data() {
    return {
      gradeIndex: [
        { id: 0, grade: 'A' },
        { id: 1, grade: 'B' },
        { id: 2, grade: 'C' },
        { id: 3, grade: 'D' },
        { id: 4, grade: 'E' },
      ],
      filterVehicle: '',
      filterDriver: '',
      filterGeofence: '',
      filterGeofenceStart: '',
      filterGeofenceStop: '',
      filterAlert: '',
      filterGrade: '',
      filterServiceStatus: '',
      filterAcc: '',
      filteredGrade: [
        { id: 0, grade: 'A' },
        { id: 1, grade: 'B' },
        { id: 2, grade: 'C' },
        { id: 3, grade: 'D' },
        { id: 4, grade: 'E' },
      ],
      filteredServiceStatus: [
        {
          id: 1,
          status: this.$t('maintenance.status.normal'),
        },
        { id: 2, status: this.$t('maintenance.status.inService') },
        {
          id: 3,
          status: this.$t('maintenance.status.lateService'),
        },
        {
          id: 4,
          status: this.$t('maintenance.status.approachingService'),
        },
      ],
      filteredAcc: [
        { id: 'on', label: this.$t('report.label.on') },
        { id: 'off', label: this.$t('report.label.off') },
      ],
      filteredCondition: [
        { id: 'in', label: this.$t('report.label.in') },
        { id: 'out', label: this.$t('report.label.out') },
      ],
      parameterFilter: this.report[this.parameter] || this.report.filter,
    }
  },
  computed: {
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
    fields() {
      const fields = []
      if (this.parameterFilter?.vehicleId) {
        const vehicleField = this.vehicleField
        vehicleField.isRequired = this.parameterFilter.vehicleId.required ?? false
        fields.push(vehicleField)
      }
      if (this.parameterFilter?.driverId) {
        const driverField = this.driverField
        driverField.isRequired = this.parameterFilter.driverId.required ?? false
        fields.push(driverField)
      }
      if (this.parameterFilter?.acc) {
        const accField = this.accField
        accField.isRequired = this.parameterFilter.acc.required ?? false
        fields.push(accField)
      }
      if (this.parameterFilter?.geofenceId) {
        const geofenceField = this.geofenceField
        geofenceField.isRequired = this.parameterFilter.geofenceId.required ?? false
        fields.push(geofenceField)
      }
      if (this.parameterFilter?.alertCode) {
        const alertField = this.alertField
        alertField.isRequired = this.parameterFilter.alertCode.required ?? false
        fields.push(alertField)
      }
      if (this.parameterFilter?.garageId) {
        const garageField = this.garageField
        garageField.isRequired = this.parameterFilter.garageId.required ?? false
        fields.push(garageField)
      }
      if (this.parameterFilter?.grade) {
        const gradeField = this.gradeField
        gradeField.isRequired = this.parameterFilter.grade.required ?? false
        fields.push(gradeField)
      }
      if (this.parameterFilter?.serviceStatus) {
        const serviceStatusField = this.serviceStatusField
        serviceStatusField.isRequired = this.parameterFilter.serviceStatus.required ?? false
        fields.push(serviceStatusField)
      }
      if (this.parameterFilter?.condition) {
        const conditionField = this.conditionField
        conditionField.isRequired = this.parameterFilter.condition.required ?? false
        fields.push(conditionField)
      }
      if (this.parameterFilter?.startGeofenceId) {
        const startGeofenceIdField = this.startGeofenceIdField
        startGeofenceIdField.isRequired = this.parameterFilter.startGeofenceId.required ?? false
        fields.push(startGeofenceIdField)
      }
      if (this.parameterFilter?.endGeofenceId) {
        const endGeofenceIdField = this.endGeofenceIdField
        endGeofenceIdField.isRequired = this.parameterFilter.endGeofenceId.required ?? false
        fields.push(endGeofenceIdField)
      }
      if (this.parameterFilter?.intersectGeofenceIds) {
        const intersectGeofenceIdsField = this.intersectGeofenceIdsField
        intersectGeofenceIdsField.isRequired =
          this.parameterFilter.intersectGeofenceIds.required ?? false
        fields.push(intersectGeofenceIdsField)
      }
      if (this.parameterFilter?.ritage) {
        const ritageField = this.ritageField
        ritageField.isRequired = this.parameterFilter.ritage.required ?? false
        fields.push(ritageField)
      }

      // Process additional filters from report.filter that have isCustom: true
      Object.keys(this.parameterFilter || {}).forEach((fieldKey) => {
        const filterConfig = this.parameterFilter[fieldKey]

        if (filterConfig && filterConfig?.isCustom === true) {
          let isShow = true

          // Check scope access if defined
          if (filterConfig?.scope) {
            if (filterConfig.scope.includes(',')) {
              isShow = this.hasAccessAll(filterConfig.scope.split(','))
            } else {
              isShow = this.hasAccess([filterConfig.scope])
            }
          }

          if (isShow && this.reportFilterFields?.[fieldKey]) {
            fields.push(this.reportFilterFields[fieldKey])
          }
        }
      })

      return fields
    },
    vehicleField() {
      const tableFields = [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: true,
        },
        {
          label: this.$t('report.fields.vehicleType'),
          key: 'vehicleType',
          isSortable: false,
          formatter: (value) => {
            return value
              ? `${value.manufacturer ?? '-'} / ${value.model ?? '-'} / ${value.type ?? '-'} `
              : '-'
          },
        },
        {
          label: this.$t('report.fields.vehicleGroup'),
          key: 'vehicle2Vgroup',
          isSortable: false,
          formatter: (value) => {
            return value && value.length > 0 ? value.map((v) => v.vgroup.name).join(', ') : '-'
          },
        },
        {
          label: 'Status',
          key: 'statusString',
          isSortable: false,
        },
      ]
      const result = {
        name: 'vehicleId',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'id',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: this.isArrayValue(this.report, 'vehicleId'),
        tableFields: tableFields,
      }
      if (this.hasAccess(['vehicle_filter_report:read'])) {
        /**
         * Defines the filters for the report modal filter component.
         * The filters include vehicle type and vehicle group, which are populated from the `vehicleList` data.
         * Each filter has a label, key, and an array of data options for the user to select from.
         * The `model` property of each filter is used to store the selected values.
         */
        result.filters = [
          {
            label: this.$t('report.fields.vehicleType'),
            key: 'vehicleType',
            data: this.getFilterValue(1000, 'vehicleType'),
            model: [],
          },
          {
            label: this.$t('report.fields.vehicleGroup'),
            key: 'vgroup',
            data: this.getFilterValue(1000, 'vgroup'),
            model: [],
          },
        ]
      }
      return result
    },
    driverField() {
      return {
        name: 'driverId',
        isShow: true,
        label: this.$t('report.fields.driver'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.driver')}`,
        trackBy: 'id',
        displayedBy: 'fullname',
        listGetter: (filter) => this.getEmployeeList(filter),
        multiple: this.isArrayValue(this.report, 'driverId'),
        tableFields: [
          {
            label: this.$t('report.fields.driver'),
            key: 'fullname',
            isSortable: true,
          },
        ],
      }
    },
    accField() {
      return {
        name: 'acc',
        isShow: true,
        label: this.$t('report.object.acc'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.object.acc')}`,
        trackBy: 'id',
        displayedBy: 'label',
        listGetter: async () => {
          return this.returnValueWithoutPagination(this.filteredAcc, 'id')
        },
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return item.label.toLowerCase().includes(search)
          })
        },
        multiple: this.isArrayValue(this.report, 'acc'),
        tableFields: [
          {
            label: this.$t('report.object.acc'),
            key: 'label',
            isSortable: true,
          },
        ],
      }
    },
    geofenceField() {
      return {
        name: 'geofenceId',
        isShow: true,
        label: this.$t('report.fields.geolocation'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.geolocation')}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple:
          this.parameterFilter.geofenceId.multiple !== undefined
            ? this.parameterFilter.geofenceId.multiple
            : this.isArrayValue(this.report, 'geofenceId'),
        tableFields: [
          {
            label: this.$t('report.fields.geolocation'),
            key: 'fenceName',
            isSortable: true,
          },
        ],
      }
    },
    alertField() {
      let lang = localStorage.getItem('language')
      return {
        name: 'alertCode',
        isShow: true,
        label: this.$t('report.fields.alertType'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.alertType')}`,
        trackBy: 'id',
        displayedBy: lang === 'en' ? 'descriptionEng' : 'descriptionIdn',
        listGetter: async () => {
          return this.returnValueWithoutPagination(
            await this.apiRequestChecker(1000, 'alertCode'),
            'id'
          )
        },
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return lang === 'en'
              ? item.descriptionEng.toLowerCase().includes(search)
              : item.descriptionIdn.toLowerCase().includes(search)
          })
        },
        multiple: this.isArrayValue(this.report, 'alertCode'),
        tableFields: [
          {
            label: this.$t('report.fields.alertType'),
            key: lang === 'en' ? 'descriptionEng' : 'descriptionIdn',
            isSortable: true,
          },
        ],
      }
    },
    garageField() {
      return {
        name: 'garageId',
        isShow: true,
        label: this.$t('report.fields.garage'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.garage')}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple: this.isArrayValue(this.report, 'garageId'),
        tableFields: [
          {
            label: this.$t('report.fields.garage'),
            key: 'fenceName',
            isSortable: true,
          },
        ],
      }
    },
    serviceStatusField() {
      return {
        name: 'serviceStatus',
        isShow: true,
        label: this.$t('report.object.serviceStatus'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.object.serviceStatus')}`,
        trackBy: 'id',
        displayedBy: 'status',
        listGetter: async () => {
          return this.returnValueWithoutPagination(this.filteredServiceStatus, 'id')
        },
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return item.status.toLowerCase().includes(search)
          })
        },
        multiple: this.isArrayValue(this.report, 'serviceStatus'),
        tableFields: [
          {
            label: this.$t('report.object.serviceStatus'),
            key: 'status',
            isSortable: true,
          },
        ],
      }
    },
    gradeField() {
      return {
        name: 'grade',
        isShow: true,
        label: this.$t('report.object.index'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.object.index')}`,
        trackBy: 'id',
        displayedBy: 'grade',
        listGetter: async () => {
          return this.returnValueWithoutPagination(this.filteredGrade, 'id')
        },
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return item.grade.toLowerCase().includes(search)
          })
        },
        multiple: this.isArrayValue(this.report, 'grade'),
        tableFields: [
          {
            label: this.$t('report.object.index'),
            key: 'grade',
            isSortable: true,
          },
        ],
      }
    },
    conditionField() {
      return {
        name: 'condition',
        isShow: true,
        label: this.$t('report.object.condition'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.object.condition')}`,
        trackBy: 'id',
        displayedBy: 'label',
        listGetter: async () => {
          return this.returnValueWithoutPagination(this.filteredCondition, 'id')
        },
        searchFunction: (items, search) => {
          search = search.toLowerCase()
          return items.filter((item) => {
            return item.label.toLowerCase().includes(search)
          })
        },

        multiple: this.isArrayValue(this.report, 'condition'),
        tableFields: [
          {
            label: this.$t('global.object.condition'),
            key: 'label',
            isSortable: true,
          },
        ],
      }
    },
    startGeofenceIdField() {
      return {
        name: 'startGeofenceId',
        isShow: true,
        label: this.$t('report.fields.startGeofence'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.startGeofence')}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple: this.isArrayValue(this.report, 'startGeofenceId'),
        tableFields: [
          {
            label: this.$t('report.fields.geolocation'),
            key: 'fenceName',
            isSortable: true,
          },
        ],
      }
    },
    endGeofenceIdField() {
      return {
        name: 'endGeofenceId',
        isShow: true,
        label: this.$t('report.fields.stopGeofence'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.stopGeofence')}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple: this.isArrayValue(this.report, 'endGeofenceId'),
        tableFields: [
          {
            label: this.$t('report.fields.geolocation'),
            key: 'fenceName',
            isSortable: true,
          },
        ],
      }
    },
    intersectGeofenceIdsField() {
      return {
        name: 'intersectGeofenceIds',
        isShow: true,
        label: this.$t('report.fields.passedGeofence'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t(
          'report.fields.passedGeofence'
        )}`,
        trackBy: 'id',
        displayedBy: 'fenceName',
        listGetter: (filter) => this.getGeofenceList(filter),
        multiple: this.isArrayValue(this.report, 'intersectGeofenceIds'),
        tableFields: [
          {
            label: this.$t('report.fields.geolocation'),
            key: 'fenceName',
            isSortable: true,
          },
        ],
      }
    },
    ritageField() {
      return {
        name: 'ritage',
        isShow: true,
        label: this.$t('report.object.ritage'),
        type: 'report-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.object.ritage')}`,
        trackBy: 'id',
        displayedBy: 'ritageName',
        listGetter: (filter) => this.getRitageList(filter),
        multiple: this.isArrayValue(this.report, 'ritage'),
        tableFields: [
          {
            label: this.$t('report.fields.ritageName'),
            key: 'ritageName',
            isSortable: true,
          },
          {
            label: this.$t('report.fields.loadingGeofence'),
            key: 'loadingName',
            isSortable: true,
          },
          {
            label: this.$t('report.fields.dumpingGeofence'),
            key: 'dumpingName',
            isSortable: true,
          },
        ],
      }
    },
    vgroupList() {
      return this.$store.state.report.vGroupList
    },
    vehicleTypeList() {
      return this.$store.state.report.vehicleTypeList
    },
    alertFilterList() {
      return this.$store.state.report.alertFilterList
    },
  },
  methods: {
    checkReportKey(key) {
      return this.report.key === key || this.report.reportKey === key
    },
    returnValueWithoutPagination(list, trackBy) {
      return {
        data: list,
        pagination: {
          total: list.length,
          page: 1,
          show: list.length,
        },
        ids: list.map((item) => {
          return item[trackBy]
        }),
      }
    },
    isArrayValue(report, prop) {
      if (report.filter && report.filter[prop]) {
        return Array.isArray(report.filter[prop].value)
      }
      return false
    },
    getListLoaded(type) {
      let loaded = false
      let list = []
      switch (type) {
        case 'alertCode':
          list = this.alertFilterList.list
          loaded = this.alertFilterList.loaded
          break
        default:
          break
      }
      return { loaded, list }
    },
    getListFilterLoaded(type) {
      let loaded = false
      let list = []
      switch (type) {
        case 'vehicleType':
          list = this.vehicleTypeList.list.map((item) => {
            return {
              id: item.vehicleTypeId,
              name: `${item.manufacturer} / ${item.model} / ${item.type}`,
            }
          })
          loaded = this.vehicleTypeList.loaded
          break
        case 'vgroup':
          list = this.vgroupList.list.map((item) => {
            return { id: item.id, name: item.name }
          })
          loaded = this.vgroupList.loaded
          break
        default:
          break
      }
      return { loaded, list }
    },
    apiRequestChecker(interval, type) {
      return new Promise((resolve) => {
        const { loaded, list } = this.getListLoaded(type)
        if (!loaded) {
          const intervalId = setInterval(() => {
            const { loaded, list } = this.getListLoaded(type)
            if (loaded) {
              clearInterval(intervalId)
              resolve(list)
            }
          }, interval)
        } else {
          resolve(list)
        }
      })
    },
    getFilterValue(interval, type) {
      return new Promise((resolve) => {
        const { loaded, list } = this.getListFilterLoaded(type)
        if (!loaded) {
          const intervalId = setInterval(() => {
            const { loaded, list } = this.getListFilterLoaded(type)
            if (loaded) {
              clearInterval(intervalId)
              resolve(list)
            }
          }, interval)
        } else {
          resolve(list)
        }
      })
    },
    async getEmployeeList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_DRIVER_FILTER,
        variables: {
          filter: {
            isDriver: true,
            isActive: true,
            orderBy: orderBy ?? JSON.stringify({ fullname: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.driversFilter.driversFilterPaginated }
      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.userId,
        }
      })
      return res
    },
    async getVehicleList(opt) {
      const { orderBy, ...otherOpt } = opt
      const self = this
      const response = await this.$apollo.query({
        query: GET_VEHICLE_FILTER,
        variables: {
          filter: {
            status: ['I', 'R', 'A'],
            orderBy: orderBy ?? JSON.stringify({ licensePlate: 'asc' }),
            isHaveSensorTemperature: this.checkReportKey('temperature') ? true : undefined,
            isHaveSensorFuel:
              this.checkReportKey('fuel') ||
              this.checkReportKey('summary-fuel') ||
              this.checkReportKey('summary-day-fuel') ||
              this.checkReportKey('fuel-recapitulation')
                ? true
                : undefined,
            isHaveSensorDoor1: this.checkReportKey('door') ? true : undefined,
            isHaveSensorDoor2: this.checkReportKey('door') ? true : undefined,
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.vehiclesFilter.vehiclesFilterPaginated }
      res.data = res.data.map((item) => {
        let status = ''
        if (item.status === 'I') {
          status = self.$t('master.status.aktif')
        } else if (item.status === 'R') {
          status = self.$t('master.status.perbaikan')
        } else {
          status = self.$t('master.status.arsip')
        }
        return Object.assign({}, item, { statusString: status })
      })
      return res
    },
    async getGeofenceList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_GEOFENCES_FILTER,
        variables: {
          filter: {
            orderBy: orderBy ?? JSON.stringify({ fenceName: 'asc' }),
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.geofencesFilter.geofencesFilterPaginated }
      res.data = res.data.map((item) => {
        return {
          ...item,
          id: item.geofenceId,
        }
      })
      return res
    },
    async getRitageList(opt) {
      const { orderBy, ...otherOpt } = opt
      const response = await this.$apollo.query({
        query: GET_RITAGE_GEOFENCES,
        variables: {
          filter: {
            ...otherOpt,
          },
        },
      })
      let res = { ...response.data.ritageGeofences.ritageGeofences }
      res.data = res.data.map((item) => {
        return {
          ...item,
          id: `${item.geofenceLoading.geofenceId}-${item.geofenceDumping.geofenceId}`,
          loadingName: item.geofenceLoading.fenceName,
          dumpingName: item.geofenceDumping.fenceName,
        }
      })
      return res
    },
  },
}
</script>
